<div id="content-section">
  <div id="content-main" style="margin-right: 370px">
    <div id="vendor-sidebar" *ngIf="showVendorSidebar" class="content-sidebar container-shadow-lg" style="width: 450px; position: fixed; right: 390px; z-index: 100000">
      <h5 class="pt-2">
        <div class="pull-right float-right">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearSearch()">Clear</button>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="showVendorSidebar = false">Hide</button>
        </div>
        Vendors
      </h5>
      <div class="clearfix"></div>
      <div class="row mt-1">
        <div class="col-md-12" id="vendor-select" style="overflow-y: scroll; border-bottom: 1px solid #ccc">
          <table class="table table-sm">
            <tbody>
              <tr *ngFor="let vendor of vendors_select">
                <td>
                  <div class="custom-control custom-checkbox" (click)="vendor.selected = !vendor.selected; toggleVendor(vendor)">
                    <input name='vendor_selected' ngDefaultControl type="checkbox" [checked]="vendor.selected" [(ngModel)]="vendor.selected" class="custom-control-input" />
                    <label class="custom-control-label">{{ vendor.label }}</label>
                  </div>
                </td>
                <td>
                  {{ vendor.balance | currency: 'USD':'symbol-narrow':'1.2-2' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div id="content-sidebar" style="width: 350px; position: fixed; right: 20px">
      <h5 class="pt-2">
        <div class="pull-right float-right">
          <button type="button" class="btn btn-sm btn-outline-secondary" *ngIf="payment_mode && showBankAccounts" (click)="loadBankAccountDetails()" [disabled]="fetchingBankDetails" title="Show bank account details">
            <i [class]="'fa fa-sync' + (fetchingBankDetails ? ' fa-spin fa-fw' : '')"></i>
          </button>
          &nbsp;
          <button type="button" class="btn btn-sm btn-outline-primary" *ngIf="payment_mode" (click)="showBankAccounts = !showBankAccounts" title="Show bank account details">
            <i class="fas fa-dollar-sign"></i>
          </button>
          &nbsp;
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearSearch()">Clear</button>
        </div>
        <span *ngIf="!payment_mode || !showBankAccounts">
          Search&nbsp;&nbsp;
          <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? search() : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
        </span>
        <span *ngIf="payment_mode && showBankAccounts">
          <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="showBankAccounts = !showBankAccounts"><i *ngIf="!searching" class="fas fa-arrow-left"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a> Bank Accounts
        </span>
      </h5>
      <div class="clearfix"></div>
      <hr class="my-1" />
      <div class="row">
        <div class="col-md-12" id="search-form" style="overflow-y: scroll; border-bottom: 1px solid #ccc">
          <div *ngIf="!payment_mode || !showBankAccounts">
            <div class="form-group">
              <label>Matter</label>
              <app-matter-search #matterSearch [matterId]="search_params.matter_id" [triggerOnChange]="true" (clearMatter)="clearVendorSelection()" (matter_id)="onMatterSelect($event)" [placeholder]="'Search by matter'" [small_input]="true"></app-matter-search>
            </div>
            <div class="form-group">
              <button type="button" class="btn btn-secondary btn-sm" (click)="toggleVendorSidebar()">Select vendors</button>
              &nbsp;&nbsp;
              <app-badge badgeType="primary">Selected vendors: {{ vendors.length }}</app-badge>
            </div>
            <div class="form-group">
              <label
                >Vendor(s)&nbsp;<app-badge badgeType="primary">{{ vendor_autocompletes.length }}</app-badge></label
              >
              <app-vendor-search [vendorId]="vendorId" [triggerOnChange]="true" [select_only]="true" [small_input]="true" [include_item]="true" (vendor)="onVendorSelect($event)"></app-vendor-search>
              <div class="py-1"></div>
              <app-badge badgeType="primary" classes="mr-1 mb-1" *ngFor="let vendor of vendor_autocompletes; let i = index">
                {{ vendor.label }}
                &nbsp;
                <a href="javascript: void(0)" class="text-white" (click)="removeVendor(i)"><i class="fas fa-close"></i></a>
              </app-badge>
            </div>
            <div class="form-group">
              <label>Account #</label>
              <input name='account_number' ngDefaultControl type="text" [(ngModel)]="search_params.account_number" class="form-control form-control-sm" />
            </div>
            <div class="form-group">
              <label>Chart of account</label>
              <select name='chart_of_account_id' ngDefaultControl class="form-control form-control-sm" [(ngModel)]="search_params.chart_of_account_id">
                <option [value]="chart_of_account.value" *ngFor="let chart_of_account of search_options.chart_of_accounts">{{ chart_of_account.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <label
                >Check Number(s)&nbsp;<app-badge badgeType="primary">{{ checkNumbersCount() }}</app-badge></label
              >
              <input name='check_numbers_entered' ngDefaultControl type="text" (ngModelChange)="checkNumbersEntered()" class="form-control form-control-sm" [(ngModel)]="checkNumbersStr" />
              <small class="form-text text-muted">Multiple check numbers allowed, separated by comma</small>
              <div class="py-1"></div>
              <app-badge badgeType="primary" classes="mr-1 mb-1" *ngFor="let checkNumber of checkNumbers; let i = index">
                #{{ checkNumber }}
                &nbsp;
                <a href="javascript: void(0)" class="text-white" (click)="removeCheckNumber(i)"><i class="fas fa-close"></i></a>
              </app-badge>
            </div>
            <div class="form-group row">
              <label class="col-12 col-form-label">Amount</label>
              <div class="col-3">
                <select name='amount_equality' ngDefaultControl [(ngModel)]="search_params.amount_equality" class="form-control form-control-sm">
                  <option [value]="'='">=</option>
                  <option [value]="'>'">&gt;</option>
                  <option [value]="'<'">&lt;</option>
                </select>
              </div>
              <div class="col-9">
                <input name='amount' ngDefaultControl type="number" [(ngModel)]="search_params.amount" min="0" class="form-control form-control-sm" />
              </div>
            </div>
            <div class="form-group row" [ngClass]="{ disabled: payment_mode }">
              <div class="col-6 border border-secondary border-top-0 border-bottom-0 border-left-0" style="border-color: #e5e5e5 !important">
                <label>Status</label>
                <div style="font-weight: normal !important">
                  <div class="custom-control custom-checkbox" (click)="payment_mode ? '' : (statuses.O = !statuses.O)">
                    <input name='statusesO' ngDefaultControl type="checkbox" [checked]="statuses.O" [(ngModel)]="statuses.O" class="custom-control-input" />
                    <label style="line-height: 18px; width: 100px" class="custom-control-label badge badge-warning">outstanding</label>
                  </div>
                </div>
                <div style="font-weight: normal !important" *ngIf="!payment_mode">
                  <div class="custom-control custom-checkbox" (click)="statuses.P = !statuses.P">
                    <input name='statusesP' ngDefaultControl type="checkbox" [checked]="statuses.P" [(ngModel)]="statuses.P" class="custom-control-input" />
                    <label style="line-height: 18px; width: 100px" class="custom-control-label badge badge-success">paid</label>
                  </div>
                </div>
                <div style="font-weight: normal !important" *ngIf="!payment_mode">
                  <div class="custom-control custom-checkbox" (click)="statuses.C = !statuses.C">
                    <input name='statusesC' ngDefaultControl type="checkbox" [checked]="statuses.C" [(ngModel)]="statuses.C" class="custom-control-input" />
                    <label style="line-height: 18px; width: 100px" class="custom-control-label badge badge-danger">contested</label>
                  </div>
                </div>
                <div style="font-weight: normal !important" *ngIf="!payment_mode">
                  <div class="custom-control custom-checkbox" (click)="statuses.V = !statuses.V">
                    <input name='statusesV' ngDefaultControl type="checkbox" [checked]="statuses.V" [(ngModel)]="statuses.V" class="custom-control-input" />
                    <label style="line-height: 18px; width: 100px" class="custom-control-label badge badge-dark">void</label>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <label>Bill Type</label>
                <div style="font-weight: normal !important">
                  <div class="custom-control custom-checkbox" (click)="payment_mode ? '' : (bill_type_names.charge = !bill_type_names.charge)">
                    <input name='bill_type_names_charge' ngDefaultControl type="checkbox" [checked]="bill_type_names.charge" [(ngModel)]="bill_type_names.charge" class="custom-control-input" />
                    <label class="custom-control-label">charge</label>
                  </div>
                </div>
                <div style="font-weight: normal !important" *ngIf="!payment_mode">
                  <div class="custom-control custom-checkbox" (click)="payment_mode ? '' : (bill_type_names.payment = !bill_type_names.payment)">
                    <input name='bill_type_names_payment' ngDefaultControl type="checkbox" [checked]="bill_type_names.payment" [(ngModel)]="bill_type_names.payment" class="custom-control-input" />
                    <label class="custom-control-label">payment</label>
                  </div>
                </div>
              </div>
            </div>
            <div style="font-weight: normal !important" *ngIf="!payment_mode">
              <div class="custom-control custom-checkbox" (click)="search_params.no_pagination = !search_params.no_pagination">
                <input name='no_pagination' noDefaultControl type="checkbox" class="custom-control-input" [(ngModel)]="search_params.no_pagination" [checked]="search_params.no_pagination" />
                <label class="custom-control-label">No pagination</label>
              </div>
            </div>
            <div class="form-group text-center">
              <button type="button" (click)="search()" [disabled]="searching" class="btn btn-primary btn-sm w-50">
                Search
                <span *ngIf="searching">&nbsp;</span>
                <i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i>
              </button>
            </div>
          </div>
          <div *ngIf="payment_mode && showBankAccounts">
            <div [class]="'card my-2' + (bankAccount.overdraft ? ' border border-danger' : '')" *ngFor="let bankAccount of bankAccounts">
              <div [class]="'card-header' + (bankAccount.overdraft ? ' text-white bg-danger' : '')">
                {{ bankAccount.name }}
              </div>
              <div class="card-body">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">Current balance</th>
                      <td>{{ bankAccount.balance | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Payment amount</th>
                      <td>{{ bankAccount.payment | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Final balance</th>
                      <td [class]="bankAccount.overdraft ? 'text-danger' : ''">{{ bankAccount.final_balance | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="content-inner" style="padding: 0px 20px 10px 20px">
      <div class="container-shadow px-3 pb-4">
        <h2 class="pt-4 text-center">To be paid</h2>
        <hr class="mt-1 mb-2" />
        <div class="sticky-top bg-white">
          <div class="py-1"></div>
          <div class="float-left pl-1">
            <app-badge badgeType="primary">To be paid: {{ count }}</app-badge>
            <span *ngIf="payment_mode">&nbsp;</span>
            <app-badge *ngIf="payment_mode" badgeType="success">Selected for payment: {{ selectedForPaymentCount() }}</app-badge>
            <h3 *ngIf="payment_mode">
              <app-badge badgeType="light" [ngClass]="{ 'text-danger': overdrafted }">Total: {{ totalCheckPaymentAmount() | currency: 'USD':'symbol-narrow':'1.2-2' }}</app-badge>
            </h3>
            <div class="form-inline mt-1" *ngIf="payment_mode">
              <label class="font-weight-bold mr-2" for="payables-bank-account">Pay from</label>
              <select
                id="payables-bank-account"
                name="payables_bank_account"
                class="form-control form-control-sm"
                [(ngModel)]="selectedPaymentBankAccountId"
                (change)="paymentBankAccountChanged()"
                [disabled]="checkSubmitting"
              >
                <option [ngValue]="null" disabled>Select a general bank account</option>
                <option *ngFor="let bankAccount of search_options.general_bank_accounts" [ngValue]="bankAccount.id">
                  {{ bankAccount.name }}{{ bankAccount.is_default ? ' (default)' : '' }}
                </option>
              </select>
              <span *ngIf="!search_options.general_bank_accounts?.length" class="text-danger ml-2">No active general bank accounts are available.</span>
            </div>
          </div>
          <div class="pull-right float-right" *ngIf="!pagination_hidden">
            <pagination
              [boundaryLinks]="true"
              [maxSize]="5"
              [itemsPerPage]="search_options.per_page"
              [totalItems]="count"
              (pageChanged)="pageChanged($event)"
              ngDefaultControl
              name='search_params_page'
              [(ngModel)]="search_params.page"
              class="pagination-sm"
              previousText="&lsaquo;"
              nextText="&rsaquo;"
              firstText="&laquo;"
              lastText="&raquo;"
            ></pagination>
          </div>
          <div class="pull-right float-right mb-3" *ngIf="!payment_mode" [ngClass]="{ 'pr-5': !pagination_hidden }">
            <a class="btn btn-primary btn-sm" [routerLink]="'/to_be_paids/new'"><i class="fas fa-plus-circle"></i>&nbsp;New to be paid</a>
          </div>
          <div class="pull-right float-right pr-3 mb-3" *ngIf="!payment_mode">
            <button type="button" class="btn btn-primary btn-sm" [disabled]="searching && search_params.making_payment" (click)="makePayment()">
              Make payment
              <span *ngIf="searching && search_params.making_payment"></span>
              <i *ngIf="searching && search_params.making_payment" class="fas fa-spinner fa-pulse fa-fw"></i>
            </button>
          </div>
          <div class="pull-right float-right mb-3" *ngIf="payment_mode" [ngClass]="{ 'pr-5': !pagination_hidden }">
            <button type="button" *ngIf="check_creation_errors" (click)="showCheckCreationErrorModal()" [disabled]="checkSubmitting" class="btn btn-danger btn-sm">Show last errors</button>
            &nbsp;&nbsp;
            <button
              type="button"
              (click)="createCheck()"
              [disabled]="disableCheckCreationButton()"
              class="btn btn-sm"
              [ngClass]="{ 'btn-success': (!disableCheckCreationButton() || checkSubmitting) && !fetchingBankDetails, 'btn-danger': disableCheckCreationButton() && !checkSubmitting && !fetchingBankDetails, 'btn-info': fetchingBankDetails }"
            >
              {{ checkCreationButtonText() }}<span *ngIf="checkSubmitting || fetchingBankDetails">&nbsp;</span><i *ngIf="checkSubmitting || fetchingBankDetails" class="fas fa-spinner fa-pulse fa-fw"></i>
            </button>
            &nbsp;&nbsp;
            <button type="button" [disabled]="checkSubmitting" class="btn btn-secondary btn-sm" (click)="cancelPayment()">Cancel payment</button>
          </div>
          <div class="clearfix"></div>
          <hr class="mt-0 mb-1" />
        </div>
        <table class="table" [ngClass]="{ 'table-striped': !payment_mode, 'table-sm': payment_mode, 'table-bordered': payment_mode }">
          <thead>
            <tr *ngIf="!payment_mode">
              <th>Date</th>
              <th>Matter</th>
              <th>Vendor</th>
              <th>Document</th>
              <th>Status</th>
              <th>Type</th>
              <th>Charge</th>
              <th>Payment</th>
              <th>Balance</th>
              <th></th>
            </tr>
            <tr *ngIf="payment_mode">
              <th style="vertical-align: bottom">
                <div style="margin-bottom: 0px" (click)="masterPaymentCheckBox = !masterPaymentCheckBox; toggleToBePaidsSelection()" class="custom-control custom-checkbox">
                  <input name='master_payment_checkbox' ngDefaultControl [(ngModel)]="masterPaymentCheckBox" [checked]="masterPaymentCheckBox" type="checkbox" class="custom-control-input" />
                  <label class="custom-control-label"></label>
                </div>
              </th>
              <th>Date</th>
              <th>Matter</th>
              <th>Vendor</th>
              <th>Document</th>
              <th>Status</th>
              <th>Type</th>
              <th>Pay</th>
              <th>Balance</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let to_be_paid of to_be_paids">
              <td style="max-width: 36px !important" *ngIf="payment_mode">
                <div style="margin-bottom: 0px" (click)="to_be_paid.selected_for_payment = !to_be_paid.selected_for_payment; paymentForBankAccounts()" class="custom-control custom-checkbox">
                  <input name='selected_for_payment' ngDefaultControl [(ngModel)]="to_be_paid.selected_for_payment" [checked]="to_be_paid.selected_for_payment" type="checkbox" class="custom-control-input" />
                  <label class="custom-control-label"></label>
                </div>
              </td>
              <td (mouseenter)="to_be_paid.hovering = true" (mouseleave)="to_be_paid.hovering = false" style="min-width: 92px !important" [title]="to_be_paid.created_at">
                <a *ngIf="to_be_paid.hovering && to_be_paid.status != 'P' && to_be_paid.bill_type_name != 'payment'" [routerLink]="'/to_be_paids/' + to_be_paid.id + '/edit'">
                  <i class="fas fa-pencil-alt"></i>
                </a>
                <span *ngIf="to_be_paid.hovering">&nbsp;</span>
                <a href="javascript: void(0)" (click)="openToBePaid(to_be_paid, to_be_paid_show)">
                  {{ to_be_paid.created_at_date }}
                </a>
              </td>
              <td>
                <a [href]="'/matters/' + to_be_paid.matter_id">{{ to_be_paid.matter_number }}</a>
              </td>
              <td>
                <a *ngIf="to_be_paid.vendor_id && to_be_paid.vendor_name" [routerLink]="'/vendors/' + to_be_paid.vendor_id">{{ to_be_paid.vendor_name }}</a>
                <span *ngIf="to_be_paid.vendor_id && !to_be_paid.vendor_name" class="text-danger" [title]="'Vendor record missing'">(deleted vendor #{{ to_be_paid.vendor_id }})</span>
              </td>
              <td>
                <span *ngIf="!to_be_paid.is_charge && to_be_paid.check_number">Check&nbsp;#</span><a *ngIf="to_be_paid.document_url" [href]="to_be_paid.document_url">{{ to_be_paid.document_text }}</a>
                <span *ngIf="!to_be_paid.document_url && to_be_paid.document_text">{{ to_be_paid.document_text }}</span>
                <span *ngIf="!to_be_paid.document_url && !to_be_paid.document_text && to_be_paid.bill_type_name == 'payment'" class="text-warning">None</span>
                <span *ngIf="!to_be_paid.document_url && !to_be_paid.document_text && to_be_paid.bill_type_name == 'charge'" class="text-muted">N/A</span>
                <br *ngIf="to_be_paid.description" />
                <span>{{ to_be_paid.description }}</span>
              </td>
              <td>
                <app-badge *ngIf="to_be_paid.status_name" [badgeType]="statusName(to_be_paid.status_name)" style="width: 100% !important">{{ to_be_paid.status_name }}</app-badge>
              </td>
              <td>
                {{ to_be_paid.bill_type_name }}
              </td>
              <td *ngIf="!payment_mode">
                <span *ngIf="to_be_paid.is_charge">{{ to_be_paid.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
              </td>
              <td *ngIf="!payment_mode">
                <span *ngIf="to_be_paid.is_payment">{{ to_be_paid.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
              </td>
              <td *ngIf="!payment_mode">
                <span>{{ to_be_paid.balance | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
              </td>
              <td *ngIf="payment_mode" style="min-width: 150px !important">
                <div class="input-group input-group-sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input name='pay' ngDefaultControl type="number" step="0.1" class="form-control" [(ngModel)]="to_be_paid.pay" />
                </div>
              </td>
              <td class="text-right" *ngIf="payment_mode">
                {{ to_be_paid.balance | currency: 'USD':'symbol-narrow':'1.2-2' }}
              </td>
              <td>
                <i class="fas fa-exclamation-circle text-danger" *ngIf="to_be_paid.is_priority"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<ng-template #check_creation_errors_modal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title text-danger">Check creation errors</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div [innerHTML]="check_creation_errors"></div>
  </div>
</ng-template>
<ng-template #to_be_paid_show let-c="close" let-d="dismiss">
  <div class="modal-body">
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
    <app-to-be-paid [toBePaidId]="showToBePaidId"></app-to-be-paid>
  </div>
</ng-template>
